<template>
    <tr>
        <td class="txt_center">
            <small><b>{{ noticeTitle }}</b></small><br>
            <select class="input_xs mgt_5" v-if="usingFlag" v-model="messageTime">
                <option
                    v-for="(object, index) in dropdownData" :key=index
                    :value="object.value"
                >{{ object.title }}</option>
            </select>
        </td>
        <td>
            <textarea rows="6" class="w_full" ref="textarea" placeholder="내용을 입력해 주세요." v-model="content" @focus="focusHandle"></textarea>
            <div class="txt_right">
                <a class="btn btn_underline blue_txt" @click="action_ShowPreview">{{ $t('reservation_settings.popup_group_settings.label_preview') }}</a>
            </div>
            <div class="kakao_status_wrap" v-if="usingKakaoAlrimtalk">
                <span class="kakao_status" :class="statusClass">{{ statusName }}</span><span>{{ statusDescription }}
                <v-icon class="btn_tooltip" v-if="isShowCommentDescription" @mouseover="mouseOver($event)" @mouseout="mouseOut">mdi-alert-circle-outline</v-icon>
                    <CommentTooltip
                        :mouseOverEvent="mouseOverEvent"
                        :content="comment"
                    />
                </span>
            </div>
        </td>
        <td class="txt_center">
            <label class="check_wrap" v-if="usingFlag">
                <input type="checkbox" v-model="isUsingMessage">
                <span class="checkmark"></span>
                {{ $t('reservation_settings.popup_group_settings.label_use') }}
            </label>
        </td>
    </tr>
</template>


<script>
import CommentTooltip from './CommentTooltip.vue'
const moment = require('../../../../../../../../util/MPMoment')
export default {
    components: { CommentTooltip },
    props: {
        value: Object,
        templateKey: String,
        noticeTitle: String,
        isShowPreview: Boolean,
    },
    data() {
        return {
            mouseOverEvent: undefined,

            isUsingMessage: undefined,
            messageTime: undefined,
            content: undefined,
            history: undefined,
        }
    },
    watch: {
        value: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if (newValue == undefined) { return }
                this.initGroup()
            }
        },
        content: {
            immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue == undefined) { return }
                if (newValue == oldValue) { return }
                this.$emit('updatePreview', {
                    templateKey: this.templateKey,
                    message: newValue
                })
                this.$emit('updateGroup', {
                    templateKey: this.templateKey,
                    isUsingMessage: this.isUsingMessage,
                    messageTime: this.messageTime,
                    content: newValue,
                })
            }
        },
        isUsingMessage: {
            immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue == undefined) { return }
                if (newValue == oldValue) { return }
                this.$emit('updateGroup', {
                    templateKey: this.templateKey,
                    isUsingMessage: newValue,
                    messageTime: this.messageTime,
                    content: this.content,
                })
            }
        },
        messageTime: {
            immediate: true,
            handler: function(newValue, oldValue) {
                if (newValue == undefined) { return }
                if (newValue == oldValue) { return }
                this.$emit('updateGroup', {
                    templateKey: this.templateKey,
                    isUsingMessage: this.isUsingMessage,
                    messageTime: newValue,
                    content: this.content
                })
            }
        }
    },
    computed: {
        dropdownData: function() {
            let array = []
            for (let i=0 ; i<13 ; i++) {
                const time = moment('2000-01-01', 'YYYY-MM-DD').startOf('days').add(8, 'hours').add(i, 'hours')
                array.push({
                    value: time.format('HH:mm'),
                    title: time.format('a hh:mm')
                })
            }
            return array
        },
        isSaaS: function() { return this.hospital.selectedHospital.isEnabledSaaS },
        usingKakaoAlrimtalk: function() {
            return this.servicesetting.setting.hasKakaoAlimAndFriendTalkLinkage
        },
        usingFlag: function() {
            return [
                'messageReservationBefore0',
                'messageReservationBefore1',
                'messageReservationBefore3'
            ].includes(this.templateKey)
        },
        statusKind: function() {
            return [
                // 사용가능
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available'),  key: 'RDY', class: 'blue', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available_detail')},
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available'),  key: 'ACT', class: 'blue', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available_detail')},
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available'),  key: 'APR', class: 'blue', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_available_detail')},

                // 검수신청
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review'),  key: 'REG', class: '', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review_detail')},
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review'),  key: 'REQ', class: '', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_review_detail')},

                // 사용불가
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'),  key: 'REJ', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail')},
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'),  key: 'STP', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail')},
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'),  key: 'DMT', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail_dormant')},
                {name: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected'),  key: 'BLK', class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail_blocked')},

                // 상태를 확인할 수 없음
                {name: '-', key: undefined, class: 'red', description: this.$t('reservation_settings.popup_group_settings.label_alimtalk_rejected_detail_unknown')}
            ]
        },
        status: function() {
            let status = this.history?.inspectionStatus ?? '-'
            return this.statusKind.find( (s) => s.key == status )
        },
        statusName: function() {
            return this.status?.name ?? ''
        },
        statusClass: function() {
            return this.status?.class ?? ''
        },
        statusDescription: function() {
            return this.status?.description ?? ''
        },
        isShowCommentDescription: function() {
            return this.status?.key == 'REJ' && this.comment != '-'
        },
        comment: function() {
            const comments = this.history?.comments ?? []
            if (comments.length == 0) { return '-' }
            const lastComment = comments[comments.length - 1]
            return lastComment.content ?? '-'
        }
    },
    methods: {
        // MARK: - Actions
        action_ShowPreview() {
            const model = { 
                templateKey: this.templateKey,
                message: this.content
            }
            this.$emit('showPreview', model)
        },

        // MARK: - Private
        initGroup() {
            switch (this.templateKey) {
                case 'messageImmediateCreate':
                    this.isUsingMessage = undefined
                    this.messageTime = undefined
                    this.content = this.value.messageImmediateCreate
                    this.history = this.value.messageImmediateCreateHistoryID
                    break
                case 'messageImmediateUpdate':
                    this.isUsingMessage = undefined
                    this.messageTime = undefined
                    this.content = this.value.messageImmediateUpdate
                    this.history = this.value.messageImmediateUpdateHistoryID
                    break
                case 'messageImmediateRemove':
                    this.isUsingMessage = undefined
                    this.messageTime = undefined
                    this.content = this.value.messageImmediateRemove
                    this.history = this.value.messageImmediateRemoveHistoryID
                    break
                case 'messageReservationBefore0': 
                    this.isUsingMessage = this.value.usingMessageReservationBefore0
                    this.messageTime = this.value.messageTimeReservationBefore0
                    this.content = this.value.messageReservationBefore0
                    this.history = this.value.messageReservationBefore0HistoryID
                    break
                case 'messageReservationBefore1':
                    this.isUsingMessage = this.value.usingMessageReservationBefore1
                    this.messageTime = this.value.messageTimeReservationBefore1
                    this.content = this.value.messageReservationBefore1
                    this.history = this.value.messageReservationBefore1HistoryID
                    break
                case 'messageReservationBefore3':
                    this.isUsingMessage = this.value.usingMessageReservationBefore3
                    this.messageTime = this.value.messageTimeReservationBefore3
                    this.content = this.value.messageReservationBefore3
                    this.history = this.value.messageReservationBefore3HistoryID
                    break
            }
        },

        // Event Handle
        focusHandle(e) {
            if (this.isSaaS && this.usingKakaoAlrimtalk && this.statusClass == 'blue') {
                if (e.target == this.$refs['textarea']) {
                    this.$emit('showEditAlert', this.templateKey)
                }
            }
        },
        mouseOver(e) {
            this.mouseOverEvent = e
        },
        mouseOut() {
            this.mouseOverEvent = undefined
        }
    }
}
</script>